export type ErrorLog = {
  error: Error;
  attributes?: Record<string, string | number | boolean>;
};

declare global {
  interface Window {
    newrelic?: {
      noticeError: (
        error: Error,
        attributes?: Record<string, string | number | boolean>,
      ) => void;
    };
  }
}

export const logClientError = ({ error, attributes }: ErrorLog) => {
  const newrelic = window?.newrelic;
  if (newrelic) {
    newrelic.noticeError(error, attributes);
  }
};
